import { render, staticRenderFns } from "./LayoutDefaultNavDrawer.vue?vue&type=template&id=65b08796&"
import script from "./LayoutDefaultNavDrawer.vue?vue&type=script&lang=js&"
export * from "./LayoutDefaultNavDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65b08796')) {
      api.createRecord('65b08796', component.options)
    } else {
      api.reload('65b08796', component.options)
    }
    module.hot.accept("./LayoutDefaultNavDrawer.vue?vue&type=template&id=65b08796&", function () {
      api.rerender('65b08796', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/default/naw-drawer/LayoutDefaultNavDrawer.vue"
export default component.exports